<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="7" @click="back"><img class="back-icon"
                                                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                </van-col>
                <van-col span="10">
                    <div class="banner-title">{{ $t('sportCount.title') }}</div>
                </van-col>
                <van-col span="7">
                    <div class="sport-type-select" @click="showSportTypeBox = true"><span class="selected">{{getLangSportType(sportType)}}</span>
                        <img class="type-icon" :src="require(`@/assets/theme/${theme}/my/02medal/01down.svg`)"></div>
                    <div class="sport-type-box" :class="{ 'sport-type-box-en': $i18n.locale == 'en' }" v-if="showSportTypeBox" ref="showSportTypeContent">
                        <div class="sport-type-item" :class="{ 'light': sportType == item }"
                             v-for="(item, index) in sportTypeList" @click="selectSportType(item)">{{getLangSportType(item)}}
                            <img v-if="sportType==item&&$i18n.locale == 'zh'" class="sport-type-icon"
                                 src="@/assets/theme/light/status/01dailyActive/02check.svg">
                        </div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div>
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 2}" @click="changeTimeType(2, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
                <div class="chart-unit" v-if="countInfo.frequencyTotal">{{$t('sportCount.unit0')}}</div>
                <div class="chart-unit2" v-if="countInfo.frequencyTotal">{{$t('sportCount.unit1')}}</div>
            </div>
            <div id="chart-box"></div>
        </div>
        <div class="total-box">
            <div class="total-item item1">
                <div class="total-re">
                    <div class="item-value"><span class="item-num">{{countInfo.frequencyTotal}}</span>{{$t('sportCount.item1Unit')}}</div>
                    <img class="item-icon icon1" :src="require(`@/assets/theme/${theme}/sport/01challengeList/06rank.svg`)">
                    <div class="item-key">{{$t('sportCount.item1')}}</div>
                </div>
            </div>
            <div class="total-item item2">
                <div class="total-re">
                    <div class="item-value"><span class="item-num">{{(countInfo.durationTotal / 3600).toFixed(2)}}</span>{{$t('sportCount.item2Unit')}}</div>
                    <img class="item-icon icon2" :src="require(`@/assets/theme/${theme}/sport/01challengeList/05time.svg`)">
                    <div class="item-key">{{$t('sportCount.item2')}}</div>
                </div>
            </div>
            <div class="total-item item3">
                <div class="total-re">
                    <div class="item-value"><span class="item-num">{{(countInfo.distanceTotal / 100000).toFixed(2)}}</span>{{$t('sportCount.unit0')}}</div>
                    <img class="item-icon icon3"
                         :src="require(`@/assets/theme/${theme}/sport/06sportCount/04distance.svg`)">
                    <div class="item-key">{{$t('sportCount.item3')}}</div>
                </div>
            </div>
            <div class="total-item item4">
                <div class="total-re">
                    <div class="item-value"><span class="item-num">{{parseInt(countInfo.calorieTotal / 1000)}}</span>{{$t('sportCount.item4Unit')}}</div>
                    <img class="item-icon icon4" :src="require(`@/assets/theme/${theme}/sport/01challengeList/10cal.svg`)">
                    <div class="item-key">{{$t('sportCount.item4')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {
        getToday,
        getNWeekFirstDay,
        getNWeekLastDay,
        getMonthStartDay,
        getMonthEndDay,
        GetDateStr, SwitchTime24,
        changeDate,
        changeMonthDate,
        GetYear
    } from "../../utils/dateUtils";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'myHr',
        data() {
            return {
                ratio: 1,
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                activeTime: 1,
                timeUnit: '',
                time: '',
                startDate: '',
                endDate: '',
                tNum: 0,
                wNum: 0,
                mNum: 0,
                yNum: 0,
                showTimeBox: false,
                myChart: null,
                showLeftOpacity: 0,
                showRightOpacity: 1,
                sportType: '全部运动',
                showSportTypeBox: false,
                sportTypeList: ['全部运动', '跑步', '登山', '骑行','室内跑','健走',  '徒步穿越','越野跑', '马拉松',  '室内游泳', '铁人三项',  '自由训练', '俯卧撑', '深蹲', '卷腹', '平板支撑', '椭圆机', '跳绳', '划船机', '滑雪登山','室内攀岩', '户外攀岩', '操场跑','户外游泳','拳击','足球','网球','羽毛球','乒乓球','篮球','皮划艇','冲浪','帆板','越野骑行','骑马','越野滑雪','爬楼','跳伞','射箭','飞盘','轮滑', '室内步行','障碍赛跑','越野摩托','摩托艇','漂流','风筝冲浪','滑水','浮潜','赛艇','龙舟','跳水','有氧运动','室内单车','踏步机','爬楼机','漫步机','瑜伽','普拉提','空手道','跆拳道','HIIT','体操','单杠','双杠','户外滑冰','室内滑冰','单板滑雪','双板滑雪','冰壶','雪地摩托','雪橇','雪车','雪鞋徒步','蹦极','跑酷','BMX','赛车','水球','排球','棒球','橄榄球','曲棍球','门球','板球','台球','保龄球','匹克球','壁球','垒球','冰球','手球','舞蹈','太极拳','健身操','武术','击剑','滑板','摔跤','钓鱼','体感游戏' ],
                chartDate:[],
                chartDistance: [],
                chartDuration: [],
                countInfo: {}
            }
        },
        watch: {
            showTimeBox: {
                handler(newVal, olVal) {
                    if (newVal) {
                        setTimeout(() => {
                            document.addEventListener('click', this.checkClick);
                        }, 0);
                    } else {
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            },
            showSportTypeBox: {
                handler(newVal, olVal) {
                    if (newVal) {
                        setTimeout(() => {
                            document.addEventListener('click', this.checkSportTypeClick);
                        }, 0);
                    } else {
                        document.removeEventListener('click', this.checkSportTypeClick);
                    }
                }
            }
        },
        mounted() {
            this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
            document.documentElement.setAttribute("theme", this.theme);
            this.timeUnit = this.$t('sportCount.time0');
            this.startDate = getNWeekFirstDay(this.wNum);
            this.endDate = getNWeekLastDay(this.wNum);
            this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            checkClick(event) {
                let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
                if (!dom.contains(event.target)) {
                    // 不在菜单范围，隐藏即可
                    if (this.showTimeBox) {
                        this.showTimeBox = false;
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            },
            checkSportTypeClick(event) {
                let dom = this.$refs.showSportTypeContent; // 这里是你的下拉菜单元素
                if (!dom.contains(event.target)) {
                    // 不在菜单范围，隐藏即可
                    if (this.showSportTypeBox) {
                        this.showSportTypeBox = false;
                        document.removeEventListener('click', this.checkSportTypeClick);
                    }
                }
            },
            checkOpacity() {
                if (this.activeTime == 0 && this.tNum <= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 1 && this.wNum >= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 2 && this.mNum >= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 3 && this.yNum >= 0) {
                    this.showRightOpacity = 1
                } else {
                    this.showRightOpacity = 0
                }
                if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 3 && GetYear(this.yNum - 1) <= 2019) {
                    this.showLeftOpacity = 1
                } else {
                    this.showLeftOpacity = 0
                }
            },
            timeLeft() {
                if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                    this.tNum++;
                    this.startDate = GetDateStr(this.tNum);
                    this.endDate = GetDateStr(this.tNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                    this.wNum--;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                    this.mNum--;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                } else if (this.activeTime == 3 && GetYear(this.yNum - 1) > 2019) {
                    this.yNum--;
                    this.startDate = GetYear(this.yNum);
                    this.time = GetYear(this.yNum) + '年';
                }
                this.getData();
                this.checkOpacity();
            },
            timeRight() {
                if (this.activeTime == 0 && this.tNum > 0) {
                    this.tNum--;
                    this.startDate = GetDateStr(this.tNum);
                    this.endDate = GetDateStr(this.tNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.wNum < 0) {
                    this.wNum++;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 2 && this.mNum < 0) {
                    this.mNum++;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                } else if (this.activeTime == 3 && this.yNum < 0) {
                    this.yNum++;
                    this.startDate = GetYear(this.yNum);
                    this.time = GetYear(this.yNum) + '年';
                }
                this.getData();
                this.checkOpacity();
            },
            changeTimeType(num, unit) {
                this.activeTime = num;
                this.timeUnit = unit;
                this.showTimeBox = false;
                if (this.activeTime == 1) {
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 2) {
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                if (this.activeTime == 0) {
                    this.startDate = GetDateStr(this.tNum);
                    this.endDate = GetDateStr(this.tNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 3) {
                    this.startDate = GetYear(this.yNum);
                    this.time = GetYear(this.yNum) + '年';
                }
                this.getData();
                this.checkOpacity();
            },
            selectSportType(item) {
                this.sportType = item;
                this.showSportTypeBox = false;
                this.getData();
            },
            getLangSportType(item) {
                return this.$t('sportType.' + item);
            },
            getData() {
                let sportType = this.sportType;
                if (sportType == '全部运动') {
                    sportType = '';
                } else if (sportType == '徒步穿越') {
                    sportType = '徒步越野';
                }
                this.$api.sport.getSportStatistics({
                    sportType: sportType,
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.countInfo = res.info;
                        this.chartDate = [];
                        this.chartDistance = [];
                        this.chartDuration = [];
                        for (let i = 0; i < res.info.data.length; i++) {
                            this.chartDate.push(changeDate(res.info.data[i].date));
                            this.chartDistance.push((res.info.data[i].distance / 100000).toFixed(2));
                            this.chartDuration.push(parseInt(res.info.data[i].duration/60));
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            },
            drawChart() {
                let maxa = Math.max.apply(null, this.chartDistance)
                let maxb = Math.max.apply(null, this.chartDuration)
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }
                let _this = this;
                if (this.countInfo.frequencyTotal == 0) {
                    this.myChart.setOption({
                        title: {
                            text: this.$t('noData'),
                            x: 'center',
                            y: 76 * this.ratio,
                            textStyle: {
                                fontFamily: 'SF',
                                fontSize: 12 * this.ratio,
                                fontWeight: 'normal',
                                color: getSkin('--text-color-2')
                            }
                        },
                        grid: {
                            top: 42 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 22 * this.ratio
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3')
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.chartDate
                        },
                        yAxis: {
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            axisLabel: false,
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            }
                        },
                        series: [
                            {
                                data: [0, 0, 0],
                                type: 'bar',
                                symbol: 'none',
                                smooth: false,
                                barWidth: 10,
                                lineStyle: {
                                    width: 3
                                }
                            }
                        ]
                    }, true);
                } else {
                    this.myChart.setOption({
                        grid: {
                            top: 42 * this.ratio,
                            bottom: 37 * this.ratio,
                            left: 41 * this.ratio,
                            right: 41 * this.ratio
                        },
                        dataZoom: { // 放大和缩放
                            type: 'inside'
                        },
                        tooltip: {
                            backgroundColor: getSkin('--bg-color-2'),
                            trigger: 'axis',
                            formatter: function (params, ticket, callback) {
                                let item = params[0];
                                let value = item.data ? item.data : 0;
                                let item1 = params[1];
                                let value1 = item1.data ? item1.data : 0;
                                if (value == 0 && value1 == 0) {
                                    return
                                }
                                let html = '';
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span> '+ _this.$t('sportCount.unit0')+'</div>'
                                html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value1 + '</span> '+ _this.$t('sportCount.unit1')+'</div>'
                                return html
                            }
                        },
                        xAxis: {
                            type: 'category',
                            axisLine: {
                                lineStyle: {
                                    color: getSkin('--line-color-2')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                            },
                            axisTick: {
                                show: false
                            },
                            data: this.chartDate
                        },
                        yAxis: [{
                            type: 'value',
                            position: 'left',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            },
                            max: this.set_max(maxa),
                            interval: this.set_max(maxa) / 4,
                        }, {
                            type: 'value',
                            position: 'right',
                            splitNumber: 4,
                            boundaryGap: [0, '10%'],
                            splitLine: {
                                lineStyle: {
                                    type: 'dotted',
                                    color: getSkin('--line-color-3')
                                }
                            },
                            axisLabel: {
                                fontSize: 11 * this.ratio,
                                fontFamily: 'D-D',
                                color: getSkin('--text-color-3'),
                                showMinLabel: false
                            },
                            max: this.set_max(maxb),
                            interval: this.set_max(maxb) / 4,
                        }],
                        series: [
                            {
                                data: this.chartDistance,
                                type: 'line',
                                showSymbol: false,
                                color: getSkin('--chart-color-1'),
                                smooth: true,
                                areaStyle: {
                                    color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                        {
                                            offset: 0,
                                            color: 'rgba(0, 255, 168, 0)',
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(0, 255, 168, 0.15)',
                                        },
                                    ]),
                                }
                            },{
                                data: this.chartDuration,
                                type: 'line',
                                yAxisIndex: 1,
                                showSymbol: false,
                                color: getSkin('--chart-color-14'),
                                smooth: true,
                                areaStyle: {
                                    color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                                        {
                                            offset: 0,
                                            color: 'rgba(39, 194, 226, 0)',
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(39, 194, 226, 0.15)',
                                        },
                                    ]),
                                }
                            },
                        ]
                    }, true);
                }
            },
            //  取最大值
            set_max(num) {
                // 1.判断是否小数：  //判断是否含有小数点：要检索的字符串值没有出现，则该方法返回 -1。
                if (num.toString().indexOf(".") != -1) {//有小数点
                    num = Math.ceil(num);//向上取整
                }
                // 2.向上取整数倍
                if (num.toString().length < 2) {
                    // 一位数1
                    num = 10;
                } else if (num.toString().length < 3) {
                    // 2位数
                    num = Math.ceil(num / 4) * 4;// 变成最近的5的倍数
                } else {
                    // 位数--先判断是不是1000...的倍数
                    var t = '';
                    for (let i = 0; i < num.toString().length - 1; i++) {
                        t += '0';//'0000...'
                    }
                    if ((num % Number(1 + t)) != 0) {//不是100的倍数

                        num = (Number(num.toString().substr(0, 1)) + 1) * Number(1 + t);
                    }
                }
                return num
            },
        },
        unmounted() {
            document.removeEventListener('click', this.checkClick);
            document.removeEventListener('click', this.checkSportTypeClick);
        }
    }
</script>

<style scoped>
    #chart-box {
        height: 198px;
        width: 100%;
    }

    .chart-unit {
        position: absolute;
        font-size: 11px;
        color: var(--chart-color-1);
        left: 14px;
        top: 30px;
    }

    .chart-unit2 {
        position: absolute;
        font-size: 11px;
        color: var(--chart-color-14);
        right: 14px;
        top: 30px;
    }

    .time-type-select {
        width: 39px;
        height: 22px;
        background-color: var(--bg-color-1);
        border-radius: 4px 4px 4px 4px;
        position: absolute;
        right: 22px;
        color: var(--text-color-1);
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .time-unit-icon {
        width: 9px;
        height: 5px;
        margin-left: 2px;
    }

    .time-type-box {
        position: absolute;
        right: 22px;
        width: 70px;
        height: 64px;
        box-shadow: 0px 0px 8px 1px rgba(216, 216, 216, 0.5);
        border-radius: 5px 5px 5px 5px;
        background-color: var(--bg-color-2);
        z-index: 1111;
        top: 36px;
        padding: 10px 0 0;
        text-align: left;
    }

    .time-type-item {
        height: 30px;
        color: var(--text-color-1);
        font-size: 15px;
        line-height: 22px;
        margin-left: 18px;
    }

    .time-check-icon {
        width: 22px;
        vertical-align: bottom;
        margin-left: 5px;
    }

    .sport-type-select {
        font-size: 12px;
        color: var(--text-color-2);
        display: flex;
        align-items: center;
        height: 45px;
        float: right;
        margin-right: 15px;
    }

    .selected {
        width: 70px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .type-icon {
        width: 12px;
        margin-left: 3px;
    }

    .sport-type-box {
        position: absolute;
        right: 30px;
        top: 88px;
        width: 168px;
        background: var(--bg-color-2);
        box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1);
        border-radius: 10px 10px 10px 10px;
        z-index: 111;
        height: 335px;
        overflow: scroll;
    }

    .sport-type-box-en {
        width: 180px;
    }

    .sport-type-item:first-child {
        padding-top: 24px;
    }

    .sport-type-item:last-child {
        padding-bottom: 12px;
    }

    .sport-type-item {
        color: var(--text-color-2);
        font-size: 12px;
        line-height: 20px;
        text-align: left;
        margin-left: 16px;
        margin-bottom: 12px;
    }


    .sport-type-icon {
        width: 16px;
        float: right;
        margin-right: 15px;
    }

    .light {
        color: var(--chart-color-1);
    }

    .total-box {
        width: 345px;
        height: 161px;
        background: var(--bg-color-2);
        border-radius: 13px 13px 13px 13px;
        margin: 10px auto;
        position: relative;
    }

    .total-item {
        width: 153px;
        height: 61px;
        background: var(--bg-color-1);
        border-radius: 10px 10px 10px 10px;
        position: absolute;
    }

    .item1 {
        top: 15px;
        left: 15px;
    }

    .item2 {
        top: 15px;
        left: 177px;
    }

    .item3 {
        top: 86px;
        left: 15px;
    }

    .item4 {
        top: 86px;
        left: 177px;
    }

    .total-re {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .item-value {
        position: absolute;
        font-size: 13px;
        color: var(--text-color-3);
        left: 17px;
        top: 7px
    }

    .item-num {
        font-size: 16px;
        color: var(--text-color-1);
        margin-right: 4px;
    }

    .item-icon {
        position: absolute;
    }

    .icon1 {
        width: 16px;
        top: 9px;
        right: 13px;
    }

    .icon2 {
        width: 16px;
        right: 11px;
        top: 8px;
    }

    .icon3 {
        width: 22px;
        right: 10px;
        top: 7px;
    }

    .icon4 {
        width: 14px;
        right: 12px;
        top: 7px;
    }

    .item-key {
        font-size: 13px;
        color: var(--text-color-2);
        position: absolute;
        left: 17px;
        top: 33px;
    }

    .time-type-select-en {
        width: 69px;
        right: 5px;
    }

    .time-type-box-en {
        width: 100px;
        right: 10px;
    }

    .time-box {
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/views/sport/06sportCount.vue